import Card from "components/Card"
import { richTextToHtml } from "utils/richTextToHtml"
import arrowRightIcon from "./arrow-right.svg"
import * as css from "./CaseStudy.module.css"

function CaseStudy({ image, text, url }) {
  let descriptionHtml = ""
  if (text?.raw) {
    const textDoc = JSON.parse(text.raw)
    descriptionHtml = richTextToHtml(textDoc).replace(/\n/g, `<br />`)
  } else if (typeof text === "string") {
    descriptionHtml = text
  }

  return (
    <Card href={url} noPadding>
      {image && (
        <div className={css.image}>
          <img src={image.url} alt={image.title} style={{ width: "100%" }} />
        </div>
      )}
      <div className={css.cardContent}>
        <div
          className={css.description}
          dangerouslySetInnerHTML={{ __html: descriptionHtml }}
        />
        <div className={css.extra}>
          <img src={arrowRightIcon} alt="Arrow to right" />
        </div>
      </div>
    </Card>
  )
}

export default CaseStudy
